var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "position-relative"
  }, [_c('b-dropdown', {
    staticClass: "filtro-dropdown",
    attrs: {
      "size": "sm",
      "text": _vm.dropdownText,
      "variant": "light"
    }
  }, _vm._l(_vm.options, function (option) {
    var _vm$selected;
    return _c('b-dropdown-item', {
      key: option.label,
      attrs: {
        "active": ((_vm$selected = _vm.selected) === null || _vm$selected === void 0 ? void 0 : _vm$selected.label) === option.label
      },
      on: {
        "click": function click($event) {
          return _vm.changed(option);
        }
      }
    }, [option.label === 'Personalizado' && _vm.dateRange.length ? _c('span', [_vm._v(" " + _vm._s(_vm.dateRangeFormatted) + " ")]) : _c('span', [_vm._v(_vm._s(option.label))])]);
  }), 1), _c('input', {
    ref: "flatpickrInput",
    staticClass: "position-absolute mt-10",
    class: {
      'd-none': !_vm.isCustomPeriod
    },
    staticStyle: {
      "z-index": "-1000",
      "color": "transparent",
      "font-size": "0px"
    },
    attrs: {
      "type": "text"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };